import { makeActionCreator } from '../../utils';
import { facebookActionTypes } from '../actionTypes';

// FACEBOOK ACTION CREATORS

/**
 * Create an action creator that sets the state value of the facebook login status, read from app props
 * Fired by the app on mount
 * @constant
 * @type {function} updateFacebookLoginStatus action creator
 */
export const updateFacebookLoginStatus = makeActionCreator(facebookActionTypes.UPDATE_FACEBOOK_LOGIN_STATUS, 'facebookLoginStatus');

/**
 * Create an action creator that sets the state value of the facebook data first name
 * Fired by the app when facebook data is fetched
 * @constant
 * @type {function} updateFacebookFirstName action creator
 */
export const updateFacebookFirstName = makeActionCreator(facebookActionTypes.UPDATE_FACEBOOK_FIRST_NAME, 'firstName');

/**
 * Create an action creator that sets the name of the facebook data last name
 * Fired by the app when facebook data is fetched
 * @constant
 * @type {function} updateFacebookLastName action creator
 */
export const updateFacebookLastName = makeActionCreator(facebookActionTypes.UPDATE_FACEBOOK_LAST_NAME, 'lastName');

/**
 * Create an action creator that sets the status of facebook data email address
 * Fired by the app when facebook data is fetched
 * @constant
 * @type {function} updateFacebookEmail action creator
 */
export const updateFacebookEmail = makeActionCreator(facebookActionTypes.UPDATE_FACEBOOK_EMAIL, 'email');

/**
 * Create an action creator that sets facebook data access token
 * Fired by the app when facebook data is fetched
 * @constant
 * @type {function} updateFacebookAccessToken action creator
 */
export const updateFacebookAccessToken = makeActionCreator(facebookActionTypes.UPDATE_FACEBOOK_ACCESS_TOKEN, 'accessToken');



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/actions/actionCreators/facebookActionCreators.js